import { useTranslation } from 'react-i18next'
import { CheckCheck } from 'lucide-react'
import { Button } from '@quebon/ui/components/button'

interface Props {
  onClick: () => void
  disabled?: boolean
}

export function MarkAllCorrectButton({ onClick, disabled }: Props) {
  const { t } = useTranslation('coaching')

  return (
    <Button type="button" variant="default" size="sm" onClick={onClick} disabled={disabled}>
      <CheckCheck data-icon="inline-start" aria-hidden="true" />
      {t('grading.markAllCorrect')}
    </Button>
  )
}
